/**
 * Status badge colours.
 *
 * Badges are filled with the status colour as stored and always carry white
 * text, so nothing here derives a foreground — the only job is substituting a
 * colour that cannot work as a fill at all.
 */

/** Statuses whose stored colour is unusable as a filled badge. */
const SUBSTITUTES = {
    // #e7e7e7 filled with white text is invisible. A mid grey keeps the
    // "inactive" reading and holds white text on either theme.
    closed: '#6b7280',
};

/** The stored colours are hex; anything else falls back to the CSS default. */
const HEX = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;

const slug = (name) => String(name ?? '').toLowerCase().trim().replace(/\s+/g, '-');

/** The colour a status is drawn in, substitutions applied. */
export const statusColor = (status) => {
    const substitute = SUBSTITUTES[slug(status?.name)];
    if (substitute) {
        return substitute;
    }

    const stored = status?.color ?? '';

    return HEX.test(String(stored).trim()) ? stored : null;
};

/** Custom properties for one status badge, or undefined to keep the CSS default. */
export const statusBadgeStyle = (status) => {
    const fill = statusColor(status);

    return fill ? { '--ck-gs-badge-color': fill } : undefined;
};
